export default __webpack_public_path__ + "static/media/app-store.18ec0ccf.png";